import { IdStyles } from "../../less/IdStyles";
import { IdIcon } from "../generic/icon/IdIcon";
export var mapRankingPlacementLeagueHeadersStyles = new Map([
    [0, { icon: IdIcon.Empty, dividerName: IdStyles.TableHeaderDefault }],
    [1, { icon: IdIcon.GoldCupIcn, dividerName: IdStyles.TableHeaderGold }],
    [2, { icon: IdIcon.SilverCupIcn, dividerName: IdStyles.TableHeaderSilver }],
    [3, { icon: IdIcon.BronzeCupIcn, dividerName: IdStyles.TableHeaderBronze }],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/MapRankingPlacementLeagueHeadersStyles.ts
// module id = 2799
// module chunks = 3